import SegmentsView from './Segments'

export default SegmentsView
